/**
 * Sponceram® — Scroll Reveal
 * IntersectionObserver-based reveal for [data-reveal] and [data-reveal-group].
 * Adds .spc-in once element crosses the viewport threshold.
 */
(function () {
  'use strict';

  const THRESHOLD = 0.12;
  const ROOT_MARGIN = '0px 0px -60px 0px';

  function init() {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('spc-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: THRESHOLD, rootMargin: ROOT_MARGIN }
    );

    document
      .querySelectorAll('[data-reveal], [data-reveal-group]')
      .forEach(function (el) {
        observer.observe(el);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
